import { Injectable } from '@angular/core';
import { DataService } from './data.service';

@Injectable({
  providedIn: 'root'
})
export class RegisterDataService {

  constructor(private dataService: DataService) { }

  register(userdetails: any) {
    return this.dataService.post('/api/Login/Register', userdetails);
  };

  ussdLogin(userdetails: any) {
    return this.dataService.post('/api/Login/UssdLogin', userdetails);
  };

  resendActivationLink(userdetails: any) {
    return this.dataService.post('/api/Login/resendActivationLink', userdetails);
  };

  verifyReseller(reseller: any) {
    return this.dataService.post('/api/Login/verifyReseller', reseller);
  };

  registerHCUser(userdetails: any) {
    return this.dataService.post('/api/Login/registerHCUser', userdetails);
  };
}
